import CloseIcon from "@/assets/icons/xmark.svg";
import { cx } from "@/utils";
import Button from "@components/Button";

import { useDrawer } from "./DrawerContext";

import styles from "./Drawer.module.css";

export interface DrawerHeaderProps extends React.HTMLProps<HTMLDivElement> {
  closeButton?: boolean;
}

const DrawerHeader: React.FunctionComponent<DrawerHeaderProps> = ({
  children,
  className,
  closeButton = true,
  ...props
}) => {
  const { onClose } = useDrawer();

  return (
    <header className={cx(styles.header, styles.padX, className)} {...props}>
      {children}
      {closeButton && (
        <Button
          icon={CloseIcon}
          variant="tertiary"
          className="closeButton"
          onClick={onClose}
        />
      )}
    </header>
  );
};
export default DrawerHeader;
